<template>
 <div class="url-census-edit" :class="{'url-census-edit__modal': isModal}">
    <span v-if="isModal" class="url-census-edit__title">{{ modalTitle }}</span>
    <div v-if="isModal" class="url-census-edit__tabs">
      <span class="url-census-edit__tabs_tab"
                   :class="{'url-census-edit__tabs_tab_error': isGIError,
                   'url-census-edit__tabs_tab_active': selectedTab === tabs.UrlGeneralInfoTab,
                   'selectable': true}"
                   @click="selectedTab = tabs.UrlGeneralInfoTab"
                   >General Info</span>
      <span class="url-census-edit__tabs_tab"
                   :class="{'url-census-edit__tabs_tab_error': isRRTError,
                   'url-census-edit__tabs_tab_active': selectedTab === tabs.UrlRankReportTargetingTab,
                   'selectable': true }"
                   @click="selectedTab = tabs.UrlRankReportTargetingTab"
                   >Rank Report Targeting</span>
      <span v-if="isAUATabVisible"
                   :class="{'url-census-edit__tabs_tab': true,
                   'url-census-edit__tabs_tab_active': selectedTab === tabs.AssociatedURLAttributesTab,
                   'selectable': true}"
                   @click="selectedTab = tabs.AssociatedURLAttributesTab"
                   >Associated URL Attributes</span>
    </div>
    <div v-else class="url-census-edit__tabs">
      <router-link class="url-census-edit__tabs_tab"
                   :class="{'url-census-edit__tabs_tab_error': isGIError}"
                   :to="{ name: 'UrlGeneralInfoTab' }"
                   active-class="url-census-edit__tabs_tab_active">General Info</router-link>
      <router-link class="url-census-edit__tabs_tab"
                   :class="{'url-census-edit__tabs_tab_error': isRRTError}"
                   :to="{ name: 'UrlRankReportTargetingTab' }"
                   active-class="url-census-edit__tabs_tab_active">Rank Report Targeting</router-link>
      <router-link v-if="isAUATabVisible"
                   class="url-census-edit__tabs_tab"
                   :to="{ name: 'AssociatedURLAttributesTab' }"
                   active-class="url-census-edit__tabs_tab_active">Associated URL Attributes</router-link>
    </div>

   <div v-if="!isDataFetched">
     <div class="url-census-edit__no-data">Awaiting Data</div>
   </div>
   <template v-else>
     <div class="url-census-edit__content-wrapper">
       <template v-if="isModal">
         <template v-if="selectedTab === tabs.UrlGeneralInfoTab"><UrlGeneralInfo /></template>
         <template v-else-if="selectedTab === tabs.UrlRankReportTargetingTab"><UrlRankReportTargeting /></template>
         <template v-else-if="selectedTab === tabs.AssociatedURLAttributesTab"><AssociatedURLAttributes /></template>
       </template>
       <template v-else>
        <router-view />
       </template>
     </div>
   </template>

   <div v-if="isDataFetched" class="url-census-edit__controls">
     <a v-if="isCBUrlVisible"
        class="url-census-edit__button url-census-edit__button_cancel url-census-edit__cb-url"
        :href="contentBriefUrl"
        target="_blank">
       Content Brief
     </a>
     <button class="url-census-edit__button url-census-edit__button_cancel"
             @click.prevent="close">
       Cancel
     </button>
     <!-- <button v-if="!isAddNew" class="url-census-edit__button url-census-edit__button_delete"
             @click.prevent="showConfirmModal">
       Delete
     </button> -->
     <button class="url-census-edit__button url-census-edit__button_submit"
             @click.prevent="apply">
       Save
     </button>
   </div>

   <div class="url-census-edit__update-loader" v-if="isDataUpdating">
     <base-loader class="url-census-edit__update-loader-ring"/>
   </div>

   <modal name="confirm-modal" v-bind="modalProps">
     <base-confirm-modal title="Are you sure you want to delete this?"
                         subtitle="This URL will be removed permanently!"
                         @confirm="confirmModal"/>
   </modal>
 </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseModalMixins from '@/common/BaseModalMixins'
import _ from 'lodash'
import baseModalProps from '@/common/BaseModalProps'
import ToasterService from '@/services/toasterService'
import moment from 'moment'
import UrlGeneralInfo from './GeneralInfo'
import UrlRankReportTargeting from './RankReportTargeting'
import AssociatedURLAttributes from './AssociatedUrlAttributes'

export default {
  name: 'UrlEdit',
  components: { UrlGeneralInfo, UrlRankReportTargeting, AssociatedURLAttributes },
  mixins: [BaseModalMixins],
  destroyed () {
    this.resetUrlData()
  },
  props: {
    urlId: {
      default: null
    }
  },
  data () {
    return {
      selectedTab: 'UrlGeneralInfoTab',
      tabs: {
        UrlGeneralInfoTab: 'UrlGeneralInfoTab',
        UrlRankReportTargetingTab: 'UrlRankReportTargetingTab',
        AssociatedURLAttributesTab: 'AssociatedURLAttributesTab'
      },
      urlDataModel: {
        id: -1,
        is_optimized: 0,
        status: null,
        content_brief: null,
        writing_status: null,
        page_type: null,
        section: null,
        url: '',
        published_url: '',
        date: null,
        rank_report_targeting: {
          geo: null,
          locale: null,
          device: null
        },
        associated_url_attributes: {}
      },
      isDataFetched: false,
      isDataUpdating: false,
      errorFields: {}
    }
  },
  watch: {
    clientId: {
      async handler (v) {
        if (v) {
          const queries = []
          !this.isSettingsQueried && queries.push(this.getUrlTargetingSettings(this.clientId))
          !this.isAddNew && queries.push(this.loadData(false))
          queries.push(this.getSession({ clientId: this.clientId }))
          await Promise.all(queries)

          if (this.isAddNew) {
            const setExploredStatus = (arr) => {
              this.urlDataModel.status = (arr.find(i => i.label.toLowerCase() === 'explored') || {})._id
              this.isDataFetched = true
            }
            if (this.urlStatuses.length) {
              setExploredStatus(this.urlStatuses)
            } else {
              const unwatch = this.$watch('urlStatuses', (v) => {
                setExploredStatus(v)
                unwatch()
              })
            }
          } else {
            this.isDataFetched = true
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState('rankZoneCommon', ['urlStatuses']),
    ...mapState('urlCensus', ['urlData', 'contentBriefUrl']),
    isModal () {
      return this.urlId != null
    },
    modalTitle () {
      return this.urlId === 'create-new-url' ? 'Create URL' : 'Edit URL'
    },
    selectedUrlId () {
      return this.urlId || this.$route.params.id
    },
    isAddNew () {
      return this.selectedUrlId === 'create-new-url'
    },
    modalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    },
    isRRTError () {
      const errorFields = Object.keys(this.errorFields)
      if (!errorFields.length) return false
      return ['geo', 'locale', 'device', 'date'].some(v => errorFields.includes(v))
    },
    isGIError () {
      const errorFields = Object.keys(this.errorFields)
      if (!errorFields.length) return false
      return ['active', 'status', 'page_type', 'section', 'url'].some(v => errorFields.includes(v))
    },
    isAUATabVisible () {
      return !this.isAddNew
    },
    isCBUrlVisible () {
      return this.contentBriefUrl && this.contentBriefUrl.length && !this.isAddNew
    }
  },
  methods: {
    ...mapActions('urlCensus', ['getUrlTargetingSettings', 'getDataByUrlId', 'removeUrlById', 'createUpdateUrl', 'resetUrlData']),
    ...mapActions('rankZoneCommon', ['getSession']),
    async loadData (updateLoadingStatus = true) {
      updateLoadingStatus && (this.isDataUpdating = true)
      await this.getDataByUrlId(this.selectedUrlId)
      this.urlDataModel = { ...this.urlData }
      updateLoadingStatus && (this.isDataUpdating = false)
      return true
    },
    close () {
      if (this.isModal) {
        this.$emit('close')
      } else {
        this.$router.push({ name: 'url-census' })
      }
    },
    showConfirmModal () {
      this.$modal.show('confirm-modal')
    },
    confirmModal (status) {
      this.$modal.hide('confirm-modal')
      if (status) {
        this.deleteURL()
      }
    },
    async deleteURL () {
      try {
        this.isDataUpdating = true
        await this.removeUrlById(this.selectedUrlId)
        this.$emit('edit')
        this.close()
      } catch (e) {
        this.isDataUpdating = false
      }
    },
    async apply () {
      this.isDataUpdating = true
      this.urlDataModel.url = this.urlDataModel.url.trim()
      const urlData = _.cloneDeep(this.urlDataModel)
      try {
        urlData.date = moment(urlData.date).format('YYYY-MM-DD')
      } catch (e) {
        console.error(e)
        return
      }
      urlData.fk_client_id = this.clientId
      const response = await this.createUpdateUrl({
        method: this.isAddNew ? 'post' : 'patch',
        urlId: this.selectedUrlId,
        urlData: JSON.stringify(urlData)
      })
      this.isDataUpdating = false

      if (!Object.keys(response).length) return false

      this.errorFields = response.error_fields

      if (!response.is_successful) {
        Object.values(this.errorFields).forEach(v => {
          ToasterService.showToast(ToasterService.ERROR_TYPE, v)
        })

        return null
      }

      const successMessage = `URL ${this.isAddNew ? 'created' : 'updated'} successfully`
      ToasterService.showToast(ToasterService.SUCCESS_TYPE, successMessage)
      if (this.isModal) {
        this.$emit('edit')
        this.$emit('close')
        return
      }
      if (this.isAddNew) {
        this.urlDataModel.id = response._id
        const currentRoutes = this.$route.path.split('/')
        this.$router.push({ path: `/strategy/url/${response.id}/${currentRoutes[currentRoutes.length - 1]}` })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .selectable {
    cursor: pointer;
  }
  .url-census-edit {
    padding: 25px 40px 0;
    position: relative;

    &__modal {
      padding-bottom: 40px;
    }

    &__title {
      margin-bottom: 30px;
      display: block;
      text-align: center;
      font-size: 32px;
      font-weight: 500;
    }
    .v--modal-overlay {
      background: none;
    }

    &__cb-url {
      margin-right: auto;
      margin-left: 0 !important;
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;
      }

      &_delete {
        background-color: $rfx-red;
        color: #fff
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }

    &__tabs {
      display: flex;
      margin-bottom: -1px;

      &_tab {
        width: max-content;
        padding: 16px 9px;
        text-align: center;
        font-size: 14px;
        color: $rfx-light-march;
        background-color: transparent;
        border: 1px solid transparent;
        text-decoration: none;

        &_error {
          color: $rfx-red;
        }

        &_active {
          background-color: #fff;
          color: $rfx-dark-march;
          font-weight: bold;
          border: 1px solid $rfx-light-steel;
          border-bottom: 1px solid #fff;
        }
      }
    }

    &__update-loader {
      position: absolute;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;
      background-color: white;
      top: 74px;
      opacity: 0.5;
      z-index: 10000;
    }

    &__update-loader-ring {
      margin-top: 200px;
    }

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border: 1px solid $rfx-light-steel;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
      flex: 1 1;
    }

    &__content-wrapper {
      padding: 10px 40px 40px;
      border: 1px solid $rfx-light-steel;
      background-color: #fff;
    }

    &::v-deep .form {
      &__input {
        display: flex;
        flex-direction: column;
        position: relative;
        margin-top: 30px;

        &_invalid[type='text'] {
          border: 1px solid $rfx-red;
          border-radius: 4px;
        }
      }

      &__error-message {
        color: $rfx-red;
        font-size: 10px;
        margin-top: 5px;
      }

      &__note {
        font-size: 14px;
        color: $rfx-dark-march;
        font-weight: normal;
        padding: 0;
        margin: 0;
      }

      &__label {
        display: block;
        font-weight: 600;
        margin-bottom: 5px;
        color: $rfx-dark-march;
      }

      &__field {
        height: 50px;
        outline: none;
        border-radius: 4px;
        font-size: 14px;
        color: $rfx-dark-march;

        &-wrapper {
        }

        &-field[type='text'] {
          width: 100%;
          box-sizing: border-box;
          padding-right: 60px;
          font-weight: 500;
          @include ellipsis;
        }

        &_error {
          border-color: $rfx-red;
          color: $rfx-red;

          &::placeholder {
            color: $rfx-red;
            font-size: 13px;
          }
        }
      }
    }
  }
</style>
